import type { Job } from "../../../models";

export interface JobMapProps {
	jobs: Job[];
	height?: string;
	zoomLevelToDisplayPoints?: number;
	lassoMode?: boolean;
	selectedFeatureIds?: Set<string>;
	onLassoComplete?: (selectedIds: Set<string>) => void;
}

export interface PopupData {
	job: Job;
	position: google.maps.LatLngLiteral;
}

export interface PolygonMetadata {
	id: string;
	paths: google.maps.LatLngLiteral[];
}

export interface PolygonRenderData {
	id: string;
	paths: google.maps.LatLngLiteral[];
	fillOpacity: number;
	fillColor: string;
	strokeColor: string | undefined;
	job: Job;
}

export interface MarkerRenderData {
	id: string;
	position: google.maps.LatLngLiteral;
	iconColor: "error" | "warning" | undefined;
	sampleId: string;
	barcode: string;
	hasChange: boolean;
	changeType: string;
	changeReason: string;
}

export interface JobMapViewModel {
	// State
	mapPoints: MarkerRenderData[];
	mapPolygons: PolygonRenderData[];
	visibleMapMarkers: MarkerRenderData[];
	visibleMapPolygons: PolygonRenderData[];
	center: google.maps.LatLngLiteral;
	zoom: number;
	bounds: google.maps.LatLngBoundsLiteral | undefined;
	activePopup: PopupData | null;
	mapsLibraryLoaded: boolean;
	polygonMetadata: PolygonMetadata[];

	// Handlers
	onBoundsChanged: (bounds: google.maps.LatLngBoundsLiteral) => void;
	onZoomChanged: (zoom: number) => void;
	onMapClick: () => void;
	onInfoWindowClose: () => void;
	onPolygonClick: (job: Job, position: google.maps.LatLngLiteral) => void;
}

export const DEFAULT_CENTER: google.maps.LatLngLiteral = {
	lat: 40.7671815905857,
	lng: -87.16533774444255,
};

export const DEFAULT_ZOOM = 12;

export const POLYGON_COLORS = [
	"#e51c23",
	"#e91e63",
	"#9c27b0",
	"#673ab7",
	"#3f51b5",
	"#5677fc",
	"#03a9f4",
	"#00bcd4",
	"#009688",
	"#259b24",
	"#8bc34a",
	"#afb42b",
	"#ff9800",
	"#ff5722",
	"#795548",
	"#607d8b",
	"#ffeb3b",
	"#cddc39",
	"#4caf50",
	"#8bc34a",
	"#cddc39",
	"#ffeb3b",
	"#ffc107",
	"#ff9800",
	"#ff5722",
	"#795548",
	"#9e9e9e",
	"#607d8b",
	"#3f51b5",
	"#2196f3",
	"#03a9f4",
	"#00bcd4",
	"#009688",
	"#4caf50",
	"#8bc34a",
	"#cddc39",
	"#ffeb3b",
	"#ffc107",
	"#ff9800",
	"#ff5722",
	"#795548",
	"#9e9e9e",
	"#607d8b",
];
